import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTheme } from "emotion-theming";
import { Backdrop } from "../../components/Themed.js";
import { getIntakeForms, getCustomFields } from "../../data/app/AppActions.js";
import { getEmployees } from "../../data/employee/EmployeeActions.js";
import {
  setClientInformation,
  setClientChildInformation,
  clearNewChild,
  createChild
} from "../../data/client/ClientActions.js";
import {
  getIntakeFields,
  getFamilyMemberTerm
} from "../../data/app/AppReducer";
import NewClient from "../../components/new-client/new-client.jsx";
import "./ClientForm.css";
import { isLocaleOrCountryInternational } from "../../common/utils.js";

class NewFamilyMemberForm extends React.Component {
  constructor(props) {
    super(props);

    this.clientSave = this.clientSave.bind(this);
  }

  async componentDidMount() {
    const {
      intakeForms,
      customFields,
      employees,
      getIntakeForms,
      getCustomFields,
      clearNewChild
    } = this.props;

    if (!intakeForms || !customFields || !employees) {
      await Promise.all([getIntakeForms(), getCustomFields(), getEmployees()]);
    }

    clearNewChild();
  }

  clientSave() {
    const { clientInformation, newChild, createChild, companyChildType } = this.props;

    return createChild(clientInformation.id, newChild, companyChildType).then(res => {
      if (res) {
        this.props.history.push("/clientPersonSelection");
      }
    });
  }

  render() {
    const fields = getIntakeFields(
      this.props.intakeForms,
      this.props.customFields,
      true
    );

    const {
      localeUUID,
      locationCountryCode
    } = this.props
    const isInternational = isLocaleOrCountryInternational(localeUUID, locationCountryCode)

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="return-client">
              <div className="content-medium">
                <NewClient
                  ifis={fields}
                  mandatoryFields={true}
                  isNewFamilyMember={true}
                  employees={this.props.employees}
                  ui={{ theme_color: this.props.theme.themeColor }}
                  client={this.props.clientInformation}
                  onChange={newClient =>
                    this.props.setClientInformation(newClient)
                  }
                  hasChildren={this.props.hasChildren}
                  children={[this.props.newChild]}
                  onChildChange={(newChild, childIndex) =>
                    this.props.setClientChildInformation(newChild, null)
                  }
                  onComplete={this.clientSave}
                  errors={this.props.clientSaveError}
                  familyMemberTerm={this.props.familyMemberTerm}
                  isInternational={isInternational}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isNewClient: state.client.isNewClient,
    hasChildren: state.client.hasChildren,
    hasServicesForClient: state.client.hasServicesForClient,
    clientInformation: state.client.clientInformation,
    clientSaveError: state.client.clientSaveError,
    companyName: state.app.businessInfo.company.name,
    companyChildType: state.app.businessInfo.company.child_type,
    intakeForms: state.app.intakeForms,
    customFields: state.app.customFields,
    employees: state.employee.employees,
    newChild: state.client.newChild,
    familyMemberTerm: getFamilyMemberTerm(state.app.businessInfo),
    localeUUID: state.app.businessInfo.company.locale_uuid,
    locationCountryCode: state.app.businessInfo.company.default_country,
  };
}

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      {
        getIntakeForms,
        getCustomFields,
        getEmployees,
        setClientInformation,
        setClientChildInformation,
        createChild,
        clearNewChild
      }
    )(NewFamilyMemberForm)
  )
);
